window.ProductCard = window.ProductCard || {};
window.__STOREFRONT_TOKEN__ = '31e0c62958ffadf52f631843f44c7dc6';

ProductCard.init = function (scope = document) {
  const productCards = scope.querySelectorAll('.nplp-product-card.not-nplp');
  console.log('productCards', productCards.length);

  if (productCards.length > 0) {
    productCards.forEach(initializeProductCard);
  }

  (function () {
    window.__ATC_DEDUP__ = {
      lastKey: '',
      lastTime: 0,
      shouldPush(key, windowMs = 1500) {
        const now = Date.now();
        if (this.lastKey === key && (now - this.lastTime) < windowMs) return false;
        this.lastKey = key;
        this.lastTime = now;
        return true;
      }
    };
  })();

  function fetchVariantForGA4(variantId) {
    const gid = `gid://shopify/ProductVariant/${Number(variantId)}`;
    const query = `
      query VariantForGA4($id: ID!) {
        productVariant(id: $id) {
          id
          title
          sku
          price { amount currencyCode }
          product { title vendor productType handle }
        }
      }
    `;
    return fetch('/api/2024-07/graphql.json', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'X-Shopify-Storefront-Access-Token': window.__STOREFRONT_TOKEN__
      },
      body: JSON.stringify({ query, variables: { id: gid } })
    })
      .then(r => r.json())
      .then(j => j && j.data && j.data.productVariant || null)
      .catch(() => null);
  }

  function addToCartIndv(variantId, parentEl) {
    parentEl.classList.remove('sizes_active');
    parentEl.classList.add('active_bag_loader');

    const btn = parentEl.querySelector('.nplp-bag-icon');

    // ---- Loader handling (attach BEFORE network calls) ----
    let loaderCleared = false;
    const clearLoader = () => {
      if (loaderCleared) return;
      loaderCleared = true;
      parentEl.classList.remove('active_bag_loader');
      document.removeEventListener('rebuy:cart.change', onRebuyChange);
      document.removeEventListener('rebuy:cart.add', onRebuyChange);
      clearTimeout(fallbackTimeout);
    };

    function onRebuyChange() {
      clearLoader();
    }

    // Listen for Rebuy cart events once (covers common names)
    document.addEventListener('rebuy:cart.change', onRebuyChange, { once: true });
    document.addEventListener('rebuy:cart.add', onRebuyChange, { once: true });

    // Fallback in case Rebuy never fires (e.g., no Rebuy widgets present)
    const fallbackTimeout = setTimeout(clearLoader, 3000);
    // ---- End loader handling ----

    const payload = {
      items: [{
        id: Number(variantId),
        quantity: 1,
        properties: {
          _section:    btn?.getAttribute('data-section')    || '',
          _widget:     btn?.getAttribute('data-widget')     || '',
          _experience: btn?.getAttribute('data-experience') || '',
          _template:   btn?.getAttribute('data-template')   || ''
        }
      }]
    };

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify(payload)
    })
      .then(() => fetch('/cart.js', { headers: { 'Accept': 'application/json' } }))
      .then(r => r.json())
      .then(cart => {
        const line = [...cart.items].reverse().find(i => Number(i.variant_id) === Number(variantId));

        const qty        = 1;
        const currency   = window.Shopify?.currency?.active || 'USD';
        const name       = line?.product_title || line?.title || String(variantId);
        const unitPrice  = line ? +(Number(line.final_price ?? line.price ?? 0) / 100).toFixed(2) : undefined;
        const variant    = line?.variant_title || undefined;
        const value      = unitPrice != null ? +(unitPrice * qty).toFixed(2) : undefined;

        // De-duped GA4 push
        const key = `${variantId}|${qty}|${currency}|${unitPrice ?? ''}`;
        if (window.__ATC_DEDUP__?.shouldPush(key)) {
          window.dataLayer = window.dataLayer || [];
          window.dataLayer.push({
            event: 'add_to_cart',
            ecommerce: {
              currency,
              ...(value != null ? { value } : {}),
              items: [{
                item_id:   String(variantId),   // variant id (not SKU)
                item_name: name,
                ...(unitPrice != null ? { price: unitPrice } : {}),
                quantity:  qty,
                ...(variant ? { item_variant: variant } : {})
              }]
            }
          });
        }

        // If Rebuy already fired, loader has cleared; if not, the fallback/once listener will handle it.
        // Optionally, you could call clearLoader() here too, but the once-listener + fallback is safer.
      })
      .catch(() => {
        // On error, clear immediately
        clearLoader();
      })
      .finally(() => {
        // Absolute guarantee against a sticky loader
        clearLoader();
      });
  }

  function initializeProductCard(card) {
    console.log('Initialize pro cards');
    const productId = card.dataset.productId;
    const variants = JSON.parse(card.querySelector('.product-variant-data').textContent);
    const materialInputs = card.querySelectorAll('.nplp-material-swatch input');
    const sizesDiv = card.querySelector('.nplp-size-swatches');
    const mainImage = card.querySelector('.product-main-image');
    const variantTitle = card.querySelector('.nplp-variant-title');
    const sizeParent = card.querySelector('.nplp-add-to-cart-wrapper');

    const renderSizes = (material) => {
  const uniqueSizes = [...new Set(variants.map(v => v.option2))];
  sizesDiv.innerHTML = '';
  sizesDiv.innerHTML += `<p class="choose-option-label">Choose Size</p>`;

  if (uniqueSizes.length > 1) {
    sizeParent.classList.add('nplp-multiple-sizes');
  } else {
    sizeParent.classList.remove('nplp-multiple-sizes');
  }

  // Track if we rendered at least 1 usable swatch
  let renderedAny = false;

  uniqueSizes.forEach(sizeValue => {
    const matchingVariant = variants.find(v => v.option1 === material && v.option2 === sizeValue);
    const isAvailable = matchingVariant?.available;
    const variantId = matchingVariant?.id || '';

    // only count "usable" when it has an id and is available
    if (variantId && isAvailable) renderedAny = true;

    sizesDiv.innerHTML += `
      <label class="nplp-size-swatch ${(!matchingVariant || !isAvailable) ? 'disabled' : ''}">
        <input type="radio" name="size-${productId}" value="${sizeValue}"
          ${variantId ? `data-variant-id="${variantId}"` : ''}
          ${(!matchingVariant || !isAvailable) ? 'disabled' : ''}>
        <span>${sizeValue}</span>
      </label>
    `;
  });

  // ✅ FALLBACK: inject default variant if nothing usable exists (Default Title products)
  if (!renderedAny) {
    const v = variants?.find(x => x?.available) || variants?.[0];
    const defaultId = v?.id;

    if (defaultId) {
      sizesDiv.innerHTML = `
        <label class="nplp-size-swatch" style="display:none;">
          <input type="radio"
                 name="size-${productId}"
                 value="Default"
                 data-variant-id="${defaultId}">
          <span>Default</span>
        </label>
      `;
      sizeParent.classList.remove('nplp-multiple-sizes');
    } else {
      console.warn('[renderSizes fallback] No default variant id found', { variants, productId });
    }
  }
};


    // Swap the rendered price pair for the chosen material. The markup comes
    // from a <template> that Liquid filled, one entry per material, so the
    // money formatting matches the active market exactly -- Shopify.formatMoney
    // is not available here and prices vary per market.
    const pricePair = card.querySelector('.nplp-card-price-pair');
    const priceVariants = card.querySelector('.nplp-card-price-variants');

    const updatePrice = (material) => {
      if (!pricePair || !priceVariants) return;
      if (pricePair.dataset.material === material) return;
      const entry = [...priceVariants.content.children].find(
        el => el.dataset.material === material
      );
      if (!entry) return;   // leave the current price rather than blanking it
      pricePair.innerHTML = entry.innerHTML;
      pricePair.dataset.material = material;
    };

    const defaultMaterial = materialInputs[0]?.value;
    if (defaultMaterial) updatePrice(defaultMaterial);
    if (defaultMaterial) renderSizes(defaultMaterial);
    if (!defaultMaterial) renderSizes(variants?.[0]?.option1 || '');


    materialInputs.forEach(input => {
      input.addEventListener('change', () => {
        const selectedMaterial = input.value;

        // Convert to handle format
        const selectedMaterialHandle = selectedMaterial
          .toLowerCase()
          .replace(/[^a-z0-9]+/g, '-')
          .replace(/(^-|-$)/g, '');

        console.log('selectedMaterial:', selectedMaterial);
        console.log('selectedMaterialHandle:', selectedMaterialHandle);

        variantTitle.textContent = selectedMaterial;
        renderSizes(selectedMaterial);
        updatePrice(selectedMaterial);

        const matchingVariant = variants.find(v => v.option1 === selectedMaterial);
        const splideElement = card.querySelector('.nplp-product-slider');
        const mainImg = splideElement?.querySelector('.product-main-image');
        const hoverImg = splideElement?.querySelector('.product-hover-image');

        const mainImageFullSrc = matchingVariant?.featured_image?.src
          ? 'https:' + matchingVariant.featured_image.src.split('?')[0]
          : '';

        if (mainImageFullSrc && mainImg) {
          mainImg.src = mainImageFullSrc;
          mainImg.alt = selectedMaterialHandle;
        }

        const imagesData = JSON.parse(card.querySelector('.product-all-images')?.textContent || '[]');

        const normalize = (url) => {
          try {
            return new URL(url, window.location.origin).pathname;
          } catch {
            return url?.split('?')[0] || '';
          }
        };

        const normalizedMainImage = normalize(mainImageFullSrc);

        let hoverImageData = imagesData.find(img => {
          const fullSrc = 'https:' + img.src;
          const normalizedHover = normalize(fullSrc);
          const matchesAlt = img.alt.includes(selectedMaterialHandle) && img.alt.includes('model');
          const isDifferent = normalizedHover !== normalizedMainImage;
          return matchesAlt && isDifferent;
        });

        if (!hoverImageData) {
          hoverImageData = imagesData.find(img => {
            const fullSrc = 'https:' + img.src;
            const normalizedHover = normalize(fullSrc);
            const matchesAlt = img.alt.includes(selectedMaterialHandle);
            const isDifferent = normalizedHover !== normalizedMainImage;
            return matchesAlt && isDifferent;
          });
        }

        if (hoverImg && hoverImageData) {
          hoverImg.src = 'https:' + hoverImageData.src;
          hoverImg.alt = hoverImageData.alt;
          console.log('Hover image updated:', hoverImageData.src);
        } else {
          console.warn('No matching hover image found; keeping existing hover image.');
        }
      });
    });

    card.querySelector('.nplp-bag-icon')?.addEventListener('click', e => {
      e.stopPropagation();
      const bagIcon = e.currentTarget;
      const parentEl = bagIcon.closest('.nplp-add-to-cart-wrapper');
      const visibleSizes = sizesDiv.querySelectorAll('.nplp-size-swatch');

      if (visibleSizes.length <= 1) {
        const singleVariant = visibleSizes[0]?.querySelector('input');
        if (singleVariant && singleVariant.dataset.variantId) {
          addToCartIndv(singleVariant.dataset.variantId, parentEl);
        }
      } else {
        sizesDiv.classList.toggle('show');
        parentEl.classList.toggle('sizes_active');

        const handleOutsideClick = (event) => {
          if (!sizesDiv.contains(event.target) && !card.querySelector('.nplp-bag-icon').contains(event.target)) {
            sizesDiv.classList.remove('show');
            parentEl.classList.remove('sizes_active');
            document.removeEventListener('click', handleOutsideClick);
          }
        };

        if (sizesDiv.classList.contains('show')) {
          document.addEventListener('click', handleOutsideClick);
        }
      }
    });

    sizesDiv.addEventListener('change', e => {
      const target = e.target;
      if (!(target instanceof HTMLInputElement)) return;
      const variantId = target.dataset.variantId;
      const parentEl = sizesDiv.closest('.nplp-add-to-cart-wrapper');
      sizesDiv.classList.remove('show');
      if (variantId) addToCartIndv(variantId, parentEl);
    });

    const splideElement = card.querySelector('.nplp-product-slider');
    const index = parseInt(splideElement.dataset.index, 10);

    function initializeResponsiveSlider(card, index) {
      const splideElement = card.querySelector('.nplp-product-slider');
      if (!splideElement) return;

      let splideInstance = null;

      const setupSplide = () => {
        const isMobile = window.innerWidth < 992;

        if (isMobile && !splideElement.classList.contains('is-mounted')) {
          splideInstance = new Splide(splideElement, {
            type: 'loop',
            perPage: 1,
            arrows: false,
            pagination: false,
            clones: 0,
            drag: false,
            swipeThreshold: 20,
            flickPower: 500,
          });

          splideInstance.mount();
          splideElement.classList.add('is-mounted');

          const slides = splideElement.querySelectorAll('.splide__slide');
          let firstSlideIndex = 0;
          slides.forEach((slide, idx) => {
            if (slide.classList.contains('first__slide')) {
              firstSlideIndex = idx;
            }
          });
          splideInstance.go(firstSlideIndex);
        }

        if (!isMobile && splideElement.classList.contains('is-mounted')) {
          splideInstance?.destroy();
          splideElement.classList.remove('is-mounted');
        }
      };

      setupSplide();
      window.addEventListener('resize', setupSplide);
    }

    initializeResponsiveSlider(card, index);
  }
};

document.addEventListener('DOMContentLoaded', () => {
  ProductCard.init(); // initialize on first page load
});
